export default __webpack_public_path__ + "static/media/instagram-icon.4d715880.svg";